import { LaboratoryResultTypeModel } from './laboratoryResultTypeModel'

export class UserLaboratoryResultFilterModel {
    public userLaboratoryResultType: LaboratoryResultTypeModel;
    public startDate: string;
    public endDate: string;
}